<template>
  <div class="w-full bg-[#161616] text-white flex flex-col items-center px-5 md:pt-[40px]">
    <h1 
      class="text-[#E1E2E6] text-center text-[40px] md:text-[50px]"
      style="
        font-family: 'Albert Sans', sans-serif;
        font-weight: 300; 
        line-height: 150%; 
        opacity: 0.9;
        max-width: 900px;
      "
    >
      Generate strong, unique passwords instantly with military-grade AES-256 encryption
    </h1>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Albert+Sans:wght@300&display=swap');
</style>